import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "booking-dashboard" }
const _hoisted_2 = { class: "container-fluid dashboard-content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8 col-xl-9" }
const _hoisted_5 = { class: "calendar-section" }
const _hoisted_6 = { class: "calendar-container" }
const _hoisted_7 = { class: "col-lg-4 col-xl-3" }
const _hoisted_8 = { class: "dashboard-sidebar d-flex flex-column gap-3" }
const _hoisted_9 = ["href"]

import { BookingCalendar } from "../calendar";
import AvailablePoints from "./components/AvailablePoints.vue";
import LocationsTable from "./components/LocationsTable.vue";
import BookingsTable from "./components/BookingsTable.vue";

export default {
  __name: 'BookingDashboard',
  props: {
	roomBookingApiUrl: { type: String, required: true },
	userApiUrl: { type: String, required: true },
  helpUrl: { type: String, required: true },
	userRole: { type: String, required: true },
},
  setup(__props) {

const props = __props;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" Left Column - Calendar "),
        _createElementVNode("div", _hoisted_4, [
          _createCommentVNode(" Calendar Integration "),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(BookingCalendar), {
                "room-booking-api-url": __props.roomBookingApiUrl,
                "user-api-url": __props.userApiUrl,
                mode: "multi-room",
                compact: false
              }, null, 8 /* PROPS */, ["room-booking-api-url", "user-api-url"])
            ])
          ])
        ]),
        _createCommentVNode(" Right Column "),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createCommentVNode(" Help Link "),
            _createElementVNode("a", {
              class: "btn btn-outline-primary btn-block",
              href: __props.helpUrl
            }, "Hilfe / FAQ", 8 /* PROPS */, _hoisted_9),
            _createCommentVNode(" Stats Cards "),
            (__props.userRole === 'student')
              ? (_openBlock(), _createBlock(AvailablePoints, { key: 0 }))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" My Bookings Table "),
            (['student', 'employee'].includes(__props.userRole))
              ? (_openBlock(), _createBlock(BookingsTable, { key: 1 }))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Location Status Table "),
            _createVNode(LocationsTable)
          ])
        ])
      ])
    ])
  ]))
}
}

}